import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BookedForForm.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import "../../../../moreCore/UI/Edit/Edit";
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import "../../../../moreCore/UI/HintBox/HintBox";
import SearchSelect from '../../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../../moreCore/UI/SearchSelect/SearchSelect";
import NumberInput from '../../../../moreCore/UI/NumberInput/NumberInput';
import "../../../../moreCore/UI/NumberInput/NumberInput";
import { AccommodationBookedForData, AdditionalBookedForForm, BookedForData } from "./BookedForFormTypes";
import "../../../../moreCore/UI/CheckBox/CheckBox";
import "../AddressHintbox/AddressHintbox";
import { AddressRef, BookedForLoadData } from "../TravelBookingListTypes";
import lang from 'dojo/_base/lang';
import AccommodationBookedForForm from './Forms/Accommodation/AccommodationBookedForForm';
import "./Forms/Accommodation/AccommodationBookedForForm";
import FlightBookedForForm from './Forms/Flight/FlightBookedForForm';
import "./Forms/Flight/FlightBookedForForm";
import TrainTransferBookedForForm from './Forms/TrainTransfer/TrainTransferBookedForForm';
import "./Forms/TrainTransfer/TrainTransferBookedForForm";
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { AddressClassnames, AddressWizardTypes } from "../../../AddressWizard/AddressWizardTypes";
import emailForm from '../../../EMail/emailForm';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';

class BookedForForm extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private isDirty: boolean = false;

    private originalData: BookedForLoadData;

    private projectEdit: MdsLax<InstanceType<typeof Edit>>;
    private descriptionEdit: MdsLax<InstanceType<typeof Edit>>;

    private tempHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private quantityPersonNumberInput: MdsLax<InstanceType<typeof NumberInput>>;
    private relationTypeHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private smokingAttitudeSearchSelect: MdsLax<InstanceType<typeof SearchSelect>>;
    private bookingStatus: MdsLax<InstanceType<typeof SearchSelect>>;

    private noteInput: MdsLax<InstanceType<typeof Edit>>;
    private noteInternalInput: MdsLax<InstanceType<typeof Edit>>;

    private sectionClass: HTMLDivElement;
    private classInput: MdsLax<InstanceType<typeof SearchSelect>>;

    private sectionPrice: HTMLDivElement;
    private pricePerUnitInput: MdsLax<InstanceType<typeof NumberInput>>;
    private priceTotalInput: MdsLax<InstanceType<typeof NumberInput>>;
    private termsOfPaymentInput: MdsLax<InstanceType<typeof SearchSelect>>;

    private additionalForm: AdditionalBookedForForm;
    private additionalFormContainer: HTMLDivElement;

    private bookingNoInput: MdsLax<InstanceType<typeof Edit>>;

    setData(data: BookedForLoadData) {
        this.originalData = data;

        switch (data.Classname) {
            case "accomodation_booked_for":
                this.additionalForm = new AccommodationBookedForForm();
                break;
            case "fligth_booked_for":
                this.additionalForm = new FlightBookedForForm();
                break;
            case "train_booked_for":
            case "transfer_booked_for":
                this.additionalForm = new TrainTransferBookedForForm();
                break;
        }
        if (data.Classname === "fligth_booked_for" || data.Classname === "train_booked_for") {

            this.hideNode(this.sectionClass, false);
            this.hideNode(this.classInput, false);
        }

        if (this.additionalForm) {
            this.additionalForm.setData(this.originalData);
            this.UiModder.domConstruct.place(this.additionalForm.domNode, this.additionalFormContainer);
            this.additionalForm.on("change", lang.hitch(this, this._onInputChange));
        }

        this.projectEdit.setValue(data.ref_vt_travel.ref_ev_project.gDisp_1, true);
        this.descriptionEdit.setValue(data.ref_vt_travel.$Displayname, true);
        if (data.ref_address) {
            this.tempHintbox.setValue(data.ref_address, true);
            //this.bookedForHintbox.setValue(data.ref_address, true);
        } else if (data.c_booked_for === "") {
            this.tempHintbox.setValue(null, true);
        } else {
            this.tempHintbox.setValue(data.c_booked_for, true);
        }
        this.quantityPersonNumberInput.setValue(data.qty_persons, true);
        if (data.ref_relation_type) {
            this.relationTypeHintbox.setValue(data.ref_relation_type, true);
        } else if (!data.c_relation_type) {
            this.relationTypeHintbox.setValue(null, true);
        }
        else {
            this.relationTypeHintbox.setValue(data.c_relation_type, true);
        }
        this.smokingAttitudeSearchSelect.setValue(data.ref_smoking_attitude, true);
        this.noteInput.setValue(data.note, true);
        this.noteInternalInput.setValue(data.note_internal_use, true);

        this.bookingNoInput.setValue(data.booking_no, true);
        this.bookingStatus.setValue(data.ref_travel_bookingstatus, true)

        if (data.Classname === "fligth_booked_for" || data.Classname === "train_booked_for") this.classInput.setValue(data.ref_vt_class, true);

        if (data.Classname !== "accomodation_booked_for" && data.Classname !== "ht_inventory_transport") {
            this.hideNode(this.sectionPrice, false);
            this.pricePerUnitInput.setValue(data.price_per_unit);
            this.priceTotalInput.setValue(data.price_total, true);
            this.termsOfPaymentInput.setValue(data.ref_travel_terms_of_payment);
        }
    }

    setAddress(newAddress: AddressRef) {
        this.originalData.ref_address = newAddress;
        this.originalData.c_booked_for = newAddress.gDisp_Name_Firstname;
        this._createNewDisplayName();
    }

    private _createNewDisplayName(): void {
        var splitDisplayName: string[] = this.originalData.$Displayname.split("-");
        var newDisplayname = this.originalData.c_booked_for + " - " + splitDisplayName[1] + " - " + splitDisplayName[2];
        this.originalData.$Displayname = newDisplayname;
    }

    updateData(): AddressRef { 
        //this.originalData.ref_address = this.bookedForHintbox.getValue("entity");
        //this.originalData.c_booked_for = this.bookedForHintbox.getValue() ? this.bookedForHintbox.getValue().gDisp_Name_Firstname : "";
        this.originalData.ref_address = this.tempHintbox.getValue("entity");
        this.originalData.c_booked_for = this.tempHintbox.getValue() ? this.tempHintbox.getValue().gDisp_Name_Firstname : "";

        this.originalData.qty_persons = this.quantityPersonNumberInput.getValue() ? this.quantityPersonNumberInput.getValue() : 1;
        this.originalData.ref_relation_type = this.relationTypeHintbox.getValue("entity") ? this.relationTypeHintbox.getValue("entity") : this.relationTypeHintbox.getValue();
        this.originalData.c_relation_type = this.relationTypeHintbox.getValue("entity") ? this.relationTypeHintbox.getValue("entity").description : this.relationTypeHintbox.getValue();
        this.originalData.ref_smoking_attitude = this.smokingAttitudeSearchSelect.getValue();
        this.originalData.note = this.noteInput.getValue();
        this.originalData.note_internal_use = this.noteInternalInput.getValue();
        this.originalData.booking_no = this.bookingNoInput.getValue();
        this.originalData.ref_travel_bookingstatus = this.bookingStatus.getValue(true);

        switch (this.originalData.Classname) {
            case "accomodation_booked_for":
                var additionalFormData = this.additionalForm.getData() as AccommodationBookedForData;
                this.originalData.ref_accommodation_roomtype = additionalFormData.ref_accommodation_roomtype;
                this.originalData.c_accommodation_roomtype = additionalFormData.c_accommodation_roomtype;
                this.originalData.room_no = additionalFormData.room_no;
                this.originalData.is_oversteered_price = additionalFormData.is_oversteered_price;
                this.originalData.price_a01 = additionalFormData.price_a01;
                this.originalData.qty_A01 = additionalFormData.qty_A01;
                this.originalData.price_a02 = additionalFormData.price_a02;
                this.originalData.qty_A02 = additionalFormData.qty_A02;
                this.originalData.price_breakfast = additionalFormData.price_breakfast;
                this.originalData.price_per_unit = additionalFormData.price_per_unit;
                this.originalData.accomodation_calc_mode = additionalFormData.accomodation_calc_mode;
                this.originalData.price_total = additionalFormData.price_total;
                this.originalData.ref_travel_terms_of_payment = additionalFormData.ref_travel_terms_of_payment;
                this.originalData.c_travel_terms_of_payment = additionalFormData.c_travel_terms_of_payment;
                this.originalData.is_active = additionalFormData.is_active;
                this.originalData.is_standby = additionalFormData.is_standby;
                this.originalData.is_breakfast = additionalFormData.is_breakfast;
                this.originalData.qty_rooms = additionalFormData.qty_rooms;
                break;
            case "fligth_booked_for":
                this.originalData.ref_vt_class = this.classInput.getValue(true);
                break;
            case "train_booked_for":
                this.originalData.ref_vt_class = this.classInput.getValue(true);
                break;
            case "transfer_booked_for":

                break;
        }

        if (this.originalData.Classname !== "accomodation_booked_for" && this.originalData.Classname !== "ht_inventory_transport") {
            this.originalData.price_per_unit = this.pricePerUnitInput.getValue();
            this.originalData.price_total = this.priceTotalInput.getValue();
            this.originalData.ref_travel_terms_of_payment = this.termsOfPaymentInput.getValue(true);
            this.originalData.c_travel_terms_of_payment = this.termsOfPaymentInput.getValue(true) ? this.termsOfPaymentInput.getValue(true).description : null;
        }

        return this.tempHintbox.getValue("entity");
    }

    getData(): BookedForLoadData {
        return this.originalData;
    }

    getIsDirty(): boolean {
        return this.isDirty;
    }

    private _onClickOpenAddressSED(e: MouseEvent): void {
        this.loadSelectEntityDialog(e,
            "selectVtAddress",
            lang.hitch(this, this._onCallbackSED),
            null,
        );
    }

    private _onCallbackSED(mode: string, data, items): void {
        if (items && items.length > 0) {
            this.tempHintbox.setValue(items[0].entry.data);
        }
    }

    private _onClickSendMail(hintbox: MdsLax<InstanceType<typeof HintBox>>, forceIfEmptyMail?: boolean) {
       
        if (!this.hasFeature("Email_Editor", "TravelBookedFor_NewMail")) return;

        let address = hintbox.getValue("entity") as AddressWizardTypes.AddressEntity;

        if (!address) {
            this.showToast(this.translate("TravelBookingForm_Error_NoContactPerson"), "fas fa-exclamation-triangle");
            return;
        }
        

        let mailAddress = "";
        if (address.EL_vt_telecommunications_adress?.length) {
            for (let entry of address.EL_vt_telecommunications_adress) {
                if (entry.Classname == AddressClassnames.email_addresses) {
                    mailAddress = entry.telecom_code;
                    break;
                }
            }
        }

        if (mailAddress || forceIfEmptyMail === true) {

            let mailForm = new emailForm();
            mailForm.show("dlg", null, this.getTabContainerName());

            if (mailAddress) {
                mailForm.addRecipients("to", [{ mailaddress: mailAddress, entityID: null }]);
            }
        } else {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.setSize("smaller");
            dlgConfirm.show(
                this.translate("TravelBookingForm_ConfirmMessage_NoEmail"),
                this.translate("TravelBookingForm_Heading_NoEmail"),
                "",
                "",
                "okcancel",
                lang.hitch(this, this._confirmNoMailCallback, hintbox)
            );
        }
    }

    private _confirmNoMailCallback(hintbox: MdsLax<InstanceType<typeof HintBox>>, response: number): void {
        if (response === 1) {
            this._onClickSendMail(hintbox, true);
        }
    }

    private _onInputChange(e): void {
        this.isDirty = true;
    }

    private _onChangQtyPersons(e): void {
        if (this.originalData.Classname === "accomodation_booked_for") {
            let currentAccommodationsForm = this.additionalForm as MdsLax<InstanceType<typeof AccommodationBookedForForm>>;
            currentAccommodationsForm.setQtyPersons(e);
            currentAccommodationsForm.resetRoomPrices();
            currentAccommodationsForm.calculateTotalPrice();
        }
        this._calculateTotalPrice();
        this._onInputChange(e);
    }

    private _onChangePricePerUnit(e): void {
        this._calculateTotalPrice();
        this._onInputChange(e);
    }

    private _calculateTotalPrice(): void {
        let pricePerUnit = this.pricePerUnitInput.getValue();
        pricePerUnit = pricePerUnit ? pricePerUnit : 0;

        let qtyPersons = this.quantityPersonNumberInput.getValue();
        qtyPersons = qtyPersons ? qtyPersons : 0;

        let priceTotal = pricePerUnit * qtyPersons;
        this.priceTotalInput.setValue(priceTotal);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.disableNode(this.projectEdit.domNode);
        this.disableNode(this.descriptionEdit.domNode);

        this.smokingAttitudeSearchSelect.loadListValues();
        this.bookingStatus.loadListValues();
        this.classInput.loadListValues();
        this.termsOfPaymentInput.loadListValues();


        this.relationTypeHintbox.enableSelectEntityDialog(true);

        //this.tempHintbox.enableSelectEntityDialog(true, lang.hitch(this, this._onClickOpenAddressSED));
        this.tempHintbox.addInlineButton(lang.hitch(this, this._onClickOpenAddressSED), this.id + "_SED");
        this.tempHintbox.addAdditionalRequestParameter("type", "none");

        if (this.hasFeature("Email_Editor", "TravelBookedFor_NewMail")) {
            this.tempHintbox.addInlineButton(lang.hitch(this, this._onClickSendMail, this.tempHintbox, false), "email", "fas fa-at", "Mail");
        }


        this.SEDconfigCallfunction = "Webtool_API__TravelBookingForm_SED_GetConfig";


        this.noteInput.setIsMultiline(true, 4);
        this.noteInternalInput.setIsMultiline(true, 4);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BookedForForm);